import gql from 'graphql-tag'

export const partnerQuery = gql`
  query Partner($oauth: String!, $payload: String!) {
    partner(oauthToken: $oauth, payloadToken: $payload) {
      accountToken
      authorization {
        provider
        uid
        accessToken
        refreshToken
        expiresAt
      }
      clientCredentialsToken
      clientId
      existingAccountRedirectUri
      externalId
      id
      logoTypeUrl
      name
      routingNumbers {
        routingNumber
      }
      website
      user {
        firstName
        lastName
        email
        dob
        address1
        address2
        city
        state
        zip
        phoneNumber
        usCitizen
      }
    }
  }
`
